import { render, staticRenderFns } from "./Roulete.vue?vue&type=template&id=0a5a8fed&lang=pug"
import script from "./Roulete.vue?vue&type=script&lang=js"
export * from "./Roulete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports